<template>
  <span>{{ truncatedText }}</span>
</template>

<script>
import { truncateByByteLength } from '@/utils/byteUtils';

export default {
  props: {
    text: {
      type: [String, null],
      default: () => "",
      required: true
    },
    maxBytes: {
      type: Number,
      default: 40 // デフォルトの最大バイト数
    }
  },
  computed: {
    truncatedText() {
      return truncateByByteLength(this.text, this.maxBytes);
    }
  }
};
</script>
